import { firestore } from "@/config/firebase";
import { SpeakerData } from "@/models/events/speakers/speakerData";
import { Schedule } from "@/vue-core/models/Schedule.model";

export default {
  async getSpeakerAndPrograms({ _ }: any, data) {
    const { eventData, renderLimit } = data;
    const programsData: { [key: string]: number } = {};
    const programSnap = await firestore("events")
      .doc(eventData)
      .collection("program")
      .orderBy("scheduledDates", "asc")
      .get();
    const speakerSnap = await firestore("events")
      .doc(eventData)
      .collection("speakers")
      .get();
    const speakersArray: Array<SpeakerData> = [];
    for (const speaker of speakerSnap.docs) {
      if (speaker.exists) speakersArray.push(speaker.data() as SpeakerData);
    }
    const speakerData = speakersArray.reduce(
      (acc, el: SpeakerData) => ({
        ...acc,
        [el.id!]: el,
      }),
      {}
    );
    for (const program of programSnap.docs) {
      const dateAndTime: Array<{
        formatDate: string;
        startTime: string;
        endTime: string;
      }> = [];
      if (program.data().scheduledDates) {
        for (const dateProgram of program.data().scheduledDates) {
          const { formatDate, startTime, endTime } = getDates({
            startDate: dateProgram.startDate.toDate(),
            endDate: dateProgram.endDate.toDate(),
            durationInMilliseconds: dateProgram.durationInMilliseconds,
          });
          dateAndTime.push({ formatDate, startTime, endTime });
        }

        for (const dateProgram of dateAndTime) {
          if (program.data().speaker) {
            if (speakerData[program.data().speaker.id].dates) {
              if (
                speakerData[program.data().speaker.id].dates[
                  dateProgram.formatDate
                ]
              ) {
                speakerData[program.data().speaker.id].dates[
                  dateProgram.formatDate
                ].push({
                  ...program.data(),
                  startTime: dateProgram.startTime,
                  endTime: dateProgram.endTime,
                });
              } else {
                speakerData[program.data().speaker.id].dates[
                  dateProgram.formatDate
                ] = [
                  {
                    ...program.data(),
                    startTime: dateProgram.startTime,
                    endTime: dateProgram.endTime,
                  },
                ];
              }
            } else {
              speakerData[program.data().speaker.id].dates = {
                [dateProgram.formatDate]: [
                  {
                    ...program.data(),
                    startTime: dateProgram.startTime,
                    endTime: dateProgram.endTime,
                  },
                ],
              };
            }
          }
        }
      }
    }
    const limit: number = renderLimit
      ? renderLimit
      : Object.keys(speakerData).length;
    let counter = 0;
    for (const key in speakerData) {
      if (counter >= limit) {
        return programsData;
      }
      counter++;
      if (Object.prototype.hasOwnProperty.call(speakerData, key)) {
        programsData[key] = speakerData[key];
      }
    }
    return programsData;
  },
  async getMainSpeaker({ _ }: any, data) {
    const { eventData } = data;
    const speakerSnap = await firestore("events")
      .doc(eventData)
      .collection("speakers")
      .where("mainSpeaker", "==", true)
      .get();
    const speakersArray: Array<SpeakerData> = [];
    for (const speaker of speakerSnap.docs) {
      speakersArray.push(speaker.data() as SpeakerData);
    }
    return speakersArray;
  },
};

function getDates(scheduledDate: Schedule) {
  const options: any = { day: "2-digit", month: "short", year: "numeric" };
  const formatDate = scheduledDate.startDate.toLocaleDateString(
    "en-GB",
    options
  );
  const startTime = convertHours(scheduledDate.startDate);
  const endTime = convertHours(scheduledDate.endDate);
  return { formatDate, startTime, endTime };
}
function convertHours(date: Date) {
  let hours: string | number = date.getHours();
  let minutes: string | number = date.getMinutes();
  let seconds: string | number = date.getSeconds();
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  const strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}
